import {useAccessToken} from "../../services/auth"
import {AsyncResultComponent} from "../../containers/AsyncResult/AsyncResult"
import React, {useEffect} from "react"
import {MainSectionTable} from "../../containers/MainSection/MainSection"
import moment from "moment"
import {useNavigateWithListPath} from "../../hooks/useListReturnPath"
import {useQueryState} from "use-location-state"
import SearchBox from "../../components/SearchBox/SearchBox"
import TitleBar from "../../components/TitleBar/TitleBar"
import {
	DataTable,
	DataTableActionHeader,
	DataTableBody,
	DataTableCard,
	DataTableCell,
	DataTableHead,
	DataTableRow,
	TablePending,
} from "../../components/DataTable/DataTable"
import {Bank, findBanks} from "../../resources/bank"
import {useAsyncResult} from "../../hooks/useAsyncResult"
import IdLink from "../../components/IdLink/IdLink"

function BankTableRow({bank}: {bank: Bank}) {
	const navigateWithListPath = useNavigateWithListPath()

	return (
		<DataTableRow
			onClick={(e) => {
				e.preventDefault()
				navigateWithListPath(`/banks/${bank.id}`)
			}}
		>
			<DataTableCell>
				<IdLink href={`/banks/${bank.id}`}>{bank.id}</IdLink>
			</DataTableCell>
			<DataTableCell className="org-name-cell">{bank.attributes.name}</DataTableCell>
			<DataTableCell>{moment(bank.attributes.createdAt).format("L")}</DataTableCell>
		</DataTableRow>
	)
}

export default function Banks() {
	const accessToken = useAccessToken()
	const [query, setQuery] = useQueryState("filter[query]", "")
	const banks = useAsyncResult(() => findBanks(accessToken, 0, 1000, query), [query])
	const [searchBox, setIsSearchLoading] = SearchBox(query, "Search Banks", 500, onSearch)

	useEffect(() => {
		banks.match(
			() => null,
			() => setIsSearchLoading(false),
			() => setIsSearchLoading(false)
		)
	}, [banks])

	function onSearch(searchTerm: string) {
		setQuery(searchTerm)
	}

	return (
		<>
			<TitleBar title={"Partner Banks"} />
			<MainSectionTable>
				<DataTableCard className={"banks-card"}>
					<DataTableActionHeader enableSticky={true} searchBox={searchBox} />

					<AsyncResultComponent asyncResult={banks} pendingComponent={<TablePending />}>
						{({value: banks}) => {
							const rows = banks.map((bank) => <BankTableRow key={bank.id} bank={bank} />)
							return (
								<>
									<DataTable
										stickyAction={true}
										fullHeight={true}
										isEmpty={rows.length === 0}
										noContentText={"No orgs found"}
									>
										<DataTableHead>
											<tr>
												<th>Id</th>
												<th>Name</th>
												<th>Created At</th>
											</tr>
										</DataTableHead>
										<DataTableBody>{rows}</DataTableBody>
									</DataTable>
								</>
							)
						}}
					</AsyncResultComponent>
				</DataTableCard>
			</MainSectionTable>
		</>
	)
}
